/* global Image */
import { writable } from 'utils/state'
import { Component } from 'utils/jsx'

import Rectangle from 'abstractions/Rectangle'
import showError from 'controllers/error'

const CACHE = new Map()

export default class Logo extends Component {
  beforeRender ({
    logos = [],
    origin = 'NW',
    x = 0, // unitless
    y = 0, // unitless
    height = 0, // unitless
    width = 0 // unitless
  } = {}) {
    this.handleLoad = this.handleLoad.bind(this)

    this.state = {
      logos: [],
      padding: this.props.padding || 0,
      loaded: writable(false),
      rectangle: new Rectangle({ x, y, width, height, origin })
    }

    this.state.loaded.subscribe(this.handleLoad)
  }

  template (props) {
    return (
      <g class='footer'>
        {this.state.rectangle.vnode({ fill: props.fill })}
      </g>
    )
  }

  afterRender () {
    const loaders = this.props.logos.map(({ name, src }) => new Promise(resolve => {
      if (CACHE.has(name)) {
        resolve(CACHE.get(name))
        return
      }

      const image = new Image()
      image.onload = () => {
        image.filename = name
        CACHE.set(name, image)
        resolve(image)
      }
      image.src = src
    }))

    Promise.all(loaders)
      .then(logos => {
        this.state.logos = logos
        this.state.loaded.set(true)
      })
      .catch(showError)
  }

  handleLoad () {
    const [paddx, paddy = paddx] = Array.isArray(this.state.padding) ? this.state.padding : [this.state.padding]
    const y = this.state.rectangle.y + paddy
    const usableHeight = this.state.rectangle.height - paddy * 2

    let x = this.state.rectangle.x + paddx
    for (const image of this.state.logos) {
      // SEE https://nicksherman.com/size-by-area/
      const area = usableHeight ** 2
      const width = Math.round(image.width * Math.sqrt(area / (image.width * image.height)))
      const height = image.height * (width / image.width)

      // Center vertically
      const yoff = (usableHeight - height) / 2

      this.render((
        <image
          x={x}
          y={y + yoff}
          width={width}
          href={image.src}
          data-filename={image.filename}
        />
      ), this.base)

      x += width + paddx
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/paper/Footer.js